// extracted by mini-css-extract-plugin
export default {"authPage":"SignIn_authPage__9RpJ+","auth":"SignIn_auth__r4ZTp","logo":"SignIn_logo__R+l1M","loader":"SignIn_loader__D5tyL"};